globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};

appCustomerSpace.Controllers.LocalManagement.HourPeriodsController = (function(superClass) {

    utils.extend(HourPeriodsController, superClass);

    function HourPeriodsController() {
        return HourPeriodsController.__super__.constructor.apply(this, arguments);
    }

    $.extend(HourPeriodsController.prototype, {
        init: function(){
            this.initEvents();

            return HourPeriodsController.__super__.init.apply(this, arguments);
        },
        initEvents: function(){
            var $form                  = $('form.regular-hours-form'),
                $specialHourForm       = $('form.special-hours-form'),
                $deleteSpecialHourForm = $('form.delete-special-hour-form');

            $form.on('change', function(){
                $(this).find('.google-alert').show();
            });

            // Open/Close checkbox
            $form.on('change', '.open-state .switchery', function(){
                var $checkbox              = $(this),
                    $formGroup             = $checkbox.closest('.form-group'),
                    $regularHoursWrapper   = $formGroup.find('.regular-hours-wrapper'),
                    $slotHourItem          = $regularHoursWrapper.find('.slot-hour-item'),
                    $openLabel             = $formGroup.find('.open-label'),
                    $closeLabel            = $formGroup.find('.close-label'),
                    $dayLabel              = $formGroup.find('.day-label'),
                    $inputOpenTime         = $slotHourItem.find('input.input-open-time'),
                    $inputCloseTime        = $slotHourItem.find('input.input-close-time'),
                    $inputOpenTimeWrapper  = $inputOpenTime.closest('.input-open-time-wrapper'),
                    $inputCloseTimeWrapper = $inputCloseTime.closest('.input-close-time-wrapper');

                if($checkbox.is(':checked')) {
                    $openLabel.show();
                    $closeLabel.hide();
                    $dayLabel.removeClass('text-muted');
                    $regularHoursWrapper.show();
                    $slotHourItem.find('input.input-destroy').val(false).end().show();

                    var dayIndex                      = parseInt($checkbox.closest('.hours-on-day').data("day-index")),
                        $previousDayHoursContent      = $form.find(`#hours-on-day-${dayIndex - 1}`),
                        $previousOpenState            = $previousDayHoursContent.find('.open-state .switchery'),
                        previousOpenTimeHoursValue    = $previousDayHoursContent.find('.open-time-hours').val(),
                        previousOpenTimeMinutesValue  = $previousDayHoursContent.find('.open-time-minutes').val(),
                        previousCloseTimeHoursValue   = $previousDayHoursContent.find('.close-time-hours').val(),
                        previousCloseTimeMinutesValue = $previousDayHoursContent.find('.close-time-minutes').val();

                    if (previousOpenTimeHoursValue && previousOpenTimeHoursValue.length == 1) {
                        previousOpenTimeHoursValue = `0${previousOpenTimeHoursValue}`
                    };
                    if (previousOpenTimeMinutesValue && previousOpenTimeMinutesValue.length == 1) {
                        previousOpenTimeMinutesValue = `0${previousOpenTimeMinutesValue}`
                    };
                    if (previousCloseTimeHoursValue && previousCloseTimeHoursValue.length == 1) {
                        previousCloseTimeHoursValue = `0${previousCloseTimeHoursValue}`
                    };
                    if (previousCloseTimeMinutesValue && previousCloseTimeMinutesValue.length == 1) {
                        previousCloseTimeMinutesValue = `0${previousCloseTimeMinutesValue}`
                    };
                    if ($previousOpenState.is(':checked') && previousOpenTimeHoursValue != "00") {
                        if ($inputOpenTime.val() == "00:00") {
                            $inputOpenTimeWrapper.find('.open-time-hours').val(previousOpenTimeHoursValue);
                            $inputOpenTimeWrapper.find('.open-time-minutes').val(previousOpenTimeMinutesValue);
                            $inputOpenTime.val(`${previousOpenTimeHoursValue}:${previousOpenTimeMinutesValue}`);
                        }
                        if ($inputCloseTime.val() == "00:00") {
                            $inputCloseTimeWrapper.find('.close-time-hours').val(previousCloseTimeHoursValue);
                            $inputCloseTimeWrapper.find('.close-time-minutes').val(previousCloseTimeMinutesValue);
                            $inputCloseTime.val(`${previousCloseTimeHoursValue}:${previousCloseTimeMinutesValue}`);
                        }
                    } else {
                        if ($inputOpenTime.val() == "00:00") {
                            $inputOpenTimeWrapper.find('.open-time-hours').val("09");
                            $inputOpenTimeWrapper.find('.open-time-minutes').val("00");
                            $inputOpenTime.val("09:00");
                        }
                        if ($inputCloseTime.val() == "00:00") {
                            $inputCloseTimeWrapper.find('.close-time-hours').val("18");
                            $inputCloseTimeWrapper.find('.close-time-minutes').val("00");
                            $inputCloseTime.val("18:00");
                        }
                    }
                } else {
                    $openLabel.hide();
                    $closeLabel.show();
                    $dayLabel.addClass('text-muted');
                    $regularHoursWrapper.find('input.input-destroy').val(true).end().hide();
                }
            });

            // Set open-time hours and minutes for RegularHour
            $form.on('input', '.input-open-time', function(){
                var $inputOpenTime        = $(this),
                    $inputOpenTimeWrapper = $inputOpenTime.closest('.input-open-time-wrapper'),
                    $openTimeHours        = $inputOpenTimeWrapper.find('.open-time-hours'),
                    $openTimeMinutes      = $inputOpenTimeWrapper.find('.open-time-minutes'),
                    openTimeValue         = $inputOpenTime.val().split(":");

                $openTimeHours.val(parseInt(openTimeValue[0]));
                $openTimeMinutes.val(parseInt(openTimeValue[1]));
            });

            // Set close-time hours and minutes for RegularHour
            $form.on('input', '.input-close-time', function(){
                var $inputCloseTime        = $(this),
                    $inputCloseTimeWrapper = $inputCloseTime.closest('.input-close-time-wrapper'),
                    $closeTimeHours        = $inputCloseTimeWrapper.find('.close-time-hours'),
                    $closeTimeMinutes      = $inputCloseTimeWrapper.find('.close-time-minutes'),
                    closeTimeValue         = $inputCloseTime.val().split(":");

                $closeTimeHours.val(parseInt(closeTimeValue[0]));
                $closeTimeMinutes.val(parseInt(closeTimeValue[1]));
            });

            // Set open-time hours and minutes for SpecialHour
            $specialHourForm.on('input', '.input-open-time', function(){
                var $inputOpenTime        = $(this),
                    $inputOpenTimeWrapper = $inputOpenTime.closest('.input-open-time-wrapper'),
                    $openTimeHours        = $inputOpenTimeWrapper.find('.open-time-hours'),
                    $openTimeMinutes      = $inputOpenTimeWrapper.find('.open-time-minutes'),
                    openTimeValue         = $inputOpenTime.val().split(":");

                $openTimeHours.val(parseInt(openTimeValue[0]));
                $openTimeMinutes.val(parseInt(openTimeValue[1]));
            });

            // Set close-time hours and minutes for SpecialHour
            $specialHourForm.on('input', '.input-close-time', function(){
                var $inputCloseTime        = $(this),
                    $inputCloseTimeWrapper = $inputCloseTime.closest('.input-close-time-wrapper'),
                    $closeTimeHours        = $inputCloseTimeWrapper.find('.close-time-hours'),
                    $closeTimeMinutes      = $inputCloseTimeWrapper.find('.close-time-minutes'),
                    closeTimeValue         = $inputCloseTime.val().split(":");

                $closeTimeHours.val(parseInt(closeTimeValue[0]));
                $closeTimeMinutes.val(parseInt(closeTimeValue[1]));
            });

            // COMMUN (remplacer 'special' par 'regular')
            // '24h/24' button on click event
            $form.on('click', '.day-all-day', function(e){
                e.preventDefault();
                var $button = $(this),
                    $regularHoursWrapper = $button.closest('.regular-hours-wrapper'),
                    $regularHourItemAllDay = $regularHoursWrapper.find('.regular-hour-item-all-day');

                if ($button.hasClass('active')) {
                    $regularHourItemAllDay.find('input.input-destroy').val(true).end().hide();
                    $regularHoursWrapper.find('.slot-hour-item').each(function(){
                        $(this).find('input.input-destroy').val(false).end().show();

                        $(this).find('.input-close-time-wrapper').prev().css("display", "flex").end().show();
                        $(this).find('.input-close-time').prop('disabled', false);
                        $(this).find('.input-close-time-wrapper').next().show();
                        $(this).find('input.input-all-day').val(false);
                        $(this).find('.open-time-hard-text').hide();
                        $(this).find('.open-time-input-field').show();
                    });
                    $regularHoursWrapper.find('.day-add-regular-hour').show();

                    $button.removeClass('active btn-primary');
                    $button.addClass('btn-default');
                    $button[0].dataset['originalTitle'] = "Apparaître ouvert 24h/24"

                } else {
                    $regularHourItemAllDay.find('input.input-destroy').val(false).end().show();
                    $regularHoursWrapper.find('.slot-hour-item').each(function(){
                        $(this).find('input.input-destroy').val(true).end().hide();
                    });
                    $regularHoursWrapper.find('.day-add-regular-hour').hide();

                    $button.addClass('active btn-primary');
                    $button.removeClass('btn-default');
                    $button[0].dataset['originalTitle'] = "Ne plus apparaître ouvert 24h/24"

                }
            });

            // COMMUN (remplacer 'special' par 'regular' et 'Special' par 'Regular')
            // Delete a timeslot
            $form.on('click', '.day-delete-hour', function(e){
                e.preventDefault();
                var $dayDeleteRegularHourButton = $(this),
                    $regularHourItem = $dayDeleteRegularHourButton.closest('.slot-hour-item'),
                    $formGroup = $dayDeleteRegularHourButton.closest('.form-group'),
                    $regularHoursWrapper = $formGroup.find('.regular-hours-wrapper'),
                    $checkbox = $formGroup.find('input[type=checkbox]'),
                    $openLabel = $formGroup.find('.open-label'),
                    $closeLabel = $formGroup.find('.close-label'),
                    is_hidden = true;

                $regularHourItem.find('input.input-destroy').val(true).end().hide();

                // if no more timeslot -> switchery should be unchecked
                $regularHoursWrapper.find('.slot-hour-item').each(function(){
                    if (!$(this).is(':hidden')) {
                        is_hidden = false;
                    }
                });
                if (is_hidden) {
                    $openLabel.hide();
                    $closeLabel.show();
                    $checkbox.click();
                }
            });

            // COMMUN (remplacer 'special' par 'regular')
            // Add a timeslot (ajax)
            $form.on('click', '.day-add-regular-hour', function(e){
                e.preventDefault();
                var $dayAddRegularHour = $(this),
                    $formGroup = $dayAddRegularHour.closest('.form-group'),
                    $regularHoursWrapper = $formGroup.find('.regular-hours-wrapper'),
                    url = $dayAddRegularHour.data("url");

                $.ajax({
                    type: "POST",
                    url: url,
                    success: function(data)
                    {
                        if (data.response == 1) {
                            if (data.views !== undefined && data.views.regularHourThumbnail !== undefined) {
                                $regularHoursWrapper.append($(data.views.regularHourThumbnail));
                                $regularHoursWrapper.find('.slot-hour-item').find('input.input-destroy').val(false);
                            }
                        } else {
                            $.each(data.errors, function(key, value) {
                                var $error = $('<p class="error">' + value[0] + '</p>');
                                $error.prependTo($dayAddRegularHour);
                            });
                        };
                    }
                });
            });


            $specialHourForm.on('change', '.input-date-from', function(){
                $(this).closest('.form-group').find('.input-date-to').focus();
            });

            // Open/Close checkbox
            $specialHourForm.on('change', '.open-state .switchery', function(){
                var $checkbox = $(this),
                    $formGroup = $checkbox.closest('.form-group'),
                    $specialHoursWrapper = $formGroup.find('.special-hours-wrapper'),
                    $openLabel = $formGroup.find('.open-label'),
                    $closeLabel = $formGroup.find('.close-label');

                if($checkbox.is(':checked')) {
                    $openLabel.show();
                    $closeLabel.hide();
                    $specialHoursWrapper.show();
                    $specialHoursWrapper.find('.slot-hour-item').find('input.input-destroy').val(false);
                    $formGroup.find('.input-day-closed').val(false);
                } else {
                    $openLabel.hide();
                    $closeLabel.show();
                    $specialHoursWrapper.hide();
                    $specialHoursWrapper.find('.slot-hour-item:not(:first)').find('input.input-destroy').val(true);
                    $specialHoursWrapper.find('.slot-hour-item').first().find('input.input-destroy').val(false);
                    $formGroup.find('.input-day-closed').val(true);
                }
            });

            // COMMUN (remplacer 'special' par 'regular')
            // '24h/24' button on click event
            $specialHourForm.on('click', '.day-all-day', function(e){
                e.preventDefault();
                var $button = $(this),
                    $specialHoursWrapper = $button.closest('.special-hours-wrapper'),
                    $specialHourItemAllDay = $specialHoursWrapper.find('.special-hour-item-all-day');

                if ($button.hasClass('active')) {
                    $specialHourItemAllDay.find('input.input-destroy').val(true).end().hide();
                    $specialHoursWrapper.find('.slot-hour-item').each(function(){
                        $(this).find('input.input-destroy').val(false).end().show();

                        $(this).find('.input-close-time-wrapper').prev().css("display", "flex").end().show();
                        $(this).find('.input-close-time').prop('disabled', false);
                        $(this).find('.input-close-time-wrapper').next().show();
                        $(this).find('input.input-all-day').val(false);
                        $(this).find('.open-time-hard-text').hide();
                        $(this).find('.open-time-input-field').show();
                    });
                    $specialHoursWrapper.find('.day-add-special-hour').show();

                    $button.removeClass('active btn-primary');
                    $button.addClass('btn-default');
                    $button[0].dataset['originalTitle'] = "Apparaître ouvert 24h/24";

                } else {
                    $specialHourItemAllDay.find('input.input-destroy').val(false).end().show();
                    $specialHoursWrapper.find('.slot-hour-item').each(function(){
                        $(this).find('input.input-destroy').val(true).end().hide();
                    });
                    $specialHoursWrapper.find('.day-add-regular-hour').hide();

                    date = $specialHourItemAllDay.closest('.new-special-hour-item').find('.datepicker').val();
                    $specialHourItemAllDay.find('input.input-date').val(date);

                    $button.addClass('active btn-primary');
                    $button.removeClass('btn-default');
                    $button[0].dataset['originalTitle'] = "Ne plus apparaître ouvert 24h/24";

                }
            });

            // COMMUN (remplacer 'special' par 'regular' et 'Special' par 'Regular')
            // Delete a timeslot
            $specialHourForm.on('click', '.day-delete-hour', function(e){
                e.preventDefault();
                var $dayDeleteSpecialHourButton = $(this),
                    $specialHourItem = $dayDeleteSpecialHourButton.closest('.slot-hour-item'),
                    $formGroup = $dayDeleteSpecialHourButton.closest('.form-group'),
                    $specialHoursWrapper = $formGroup.find('.special-hours-wrapper'),
                    $checkbox = $formGroup.find('input[type=checkbox]'),
                    $openLabel = $formGroup.find('.open-label'),
                    $closeLabel = $formGroup.find('.close-label'),
                    is_hidden = true;

                $specialHourItem.find('input.input-destroy').val(true).end().hide();

                // if no more timeslot -> switchery should be unchecked
                $specialHoursWrapper.find('.slot-hour-item').each(function(){
                    if (!$(this).is(':hidden')) {
                        is_hidden = false;
                    }
                });
                if (is_hidden) {
                    $openLabel.hide();
                    $closeLabel.show();
                    $checkbox.click();
                }
            });

            // COMMUN (remplacer 'special' par 'regular')
            // Add a timeslot (ajax)
            $specialHourForm.on('click', '.day-add-special-hour', function(e){
                e.preventDefault();
                var $dayAddSpecialHour = $(this),
                    $formGroup = $dayAddSpecialHour.closest('.form-group'),
                    $specialHoursWrapper = $formGroup.find('.special-hours-wrapper'),
                    url = $dayAddSpecialHour.data("url");

                $.ajax({
                    type: "POST",
                    url: url,
                    success: function(data)
                    {
                        if (data.response == 1) {
                            if (data.views !== undefined && data.views.specialHourThumbnail !== undefined) {
                                $specialHoursWrapper.append($(data.views.specialHourThumbnail));
                                $specialHoursWrapper.find('.slot-hour-item').find('input.input-destroy').val(false);
                            }
                        } else {
                            $.each(data.errors, function(key, value) {
                                var $error = $('<p class="error">' + value[0] + '</p>');
                                $error.prependTo($dayAddSpecialHour);
                            });
                        };
                    }
                });
            });

            $deleteSpecialHourForm.each(function(){
                $(this).on('submit', function(e){
                    var currentForm = this;

                    var modalOptions = {
                        message: "Voulez-vous vraiment supprimer ces horaires exceptionnels ?",
                        buttons: {
                            confirm: {
                                label: "Confirmer",
                                className: "btn btn-primary float-right mr-10",
                            },
                            cancel: {
                                label: "Annuler",
                                className: "btn btn-default float-right",
                            }
                        },
                        callback: function(result) {
                            if(result) {
                                currentForm.submit();
                            }
                            this.hide();
                        }
                    };

                    e.preventDefault();
                    bootbox.confirm(modalOptions);
                });
            });
        }
    });

    return HourPeriodsController;

})(appCustomerSpace.Controllers.LocalManagement.MainController);
